import { Box, Container, Grid } from "@material-ui/core";
import React from "react";
import { RouteChildrenProps } from "react-router";
import { Footer } from "../../Footer";
import { Banner } from "../../partials/Banner/Banner";
import { Page } from "../../partials/Page";
import { ProfileNavigation } from "./ProfileNavigation";

export default (props: RouteChildrenProps) => {
  return (
    <Page>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <ProfileNavigation {...props} />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box mt={12} mb={8}>
            <Banner type="upgrade-premium" size="large" />
          </Box>
        </Grid>
      </Container>
      <Footer />
    </Page>
  );
};
